<app-loading />
<nz-layout>
  <!-- navbar -->
  @if (showNavbar) {
    <app-navbar></app-navbar>
  }

  <nz-layout>
    <!-- sidebar -->
    @if (isLogged || isPreviewMode) {
      <nz-sider class="sidebar" [(nzCollapsed)]="isCollapsed" [nzWidth]="200" [nzCollapsedWidth]="43">
        <div class="sider-content">
          <app-sidebar [isCollapsed]="isCollapsed"></app-sidebar>
          <div class="collapse">
            <span class="icon-collapse" (click)="toggleCollapsed()" nz-icon nzType="step-backward" nzTheme="outline"></span>
          </div>
        </div>
      </nz-sider>
    }
    <!-- body -->
    <nz-content>
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>

  <!-- footer -->
  @if (showFooter) {
    <app-footer></app-footer>
  }
  <!-- Cookie button -->
  <!-- <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
  Cookie policy div 
  <div id="ot-sdk-cookie-policy"></div>-->
</nz-layout>
